import React from 'react';
import { observer } from 'mobx-react';

import { Field } from 'libs/forms/views/field';
import { Validation } from 'libs/forms/views/validation';
import { InputWrapper, WrappedInput } from 'libs/forms/styles';
import { StringFieldStore } from 'libs/forms/fieldStores';

import i18next from 'i18next';

@observer
export class PhoneField extends Field {
  static defaultStore = StringFieldStore;
  focusAfterDelete = () => {
    const { fieldStore } = this.props;
    if (fieldStore.ref) fieldStore.ref.focus();
    fieldStore.SetFocus(true);
  };

  render() {
    const { fieldStore, editComponent, noValidation, responsive } = this.props;
    const { libPhone } = fieldStore;
    let placeholder;
    let value;
    if (!libPhone) {
      placeholder = '...loading phone number data';
      value = '';
    } else {
      placeholder =
        fieldStore.conf.placeholder && i18next.t(fieldStore.conf.placeholder);
      value = fieldStore.conf.prefixValue
        ? fieldStore.conf.prefixValue + fieldStore.value
        : fieldStore.value;
    }
    const Tag = editComponent || InputWrapper;
    return (
      <Tag focussed={fieldStore.isFocussed} responsive={responsive}>
        <WrappedInput
          ref={ref => {
            fieldStore.SetRef(ref);
          }}
          autoFocus={fieldStore.autoFocus}
          type='text'
          disabled={libPhone === null}
          id={this.inputId}
          className='inputNoBorder'
          // eslint-disable-next-line
          value={value}
          placeholder={placeholder}
          onBlur={this.onBlur}
          onChange={this.updateValue}
          onFocus={this.onFocus}
          posting={
            fieldStore.formStore.posting
              ? fieldStore.formStore.posting
              : undefined
          }
          autoComplete='off'
          responsive={responsive}
        />
        {!noValidation && (
          <Validation
            fieldStore={fieldStore}
            handleClick={this.focusAfterDelete}
          />
        )}
      </Tag>
    );
  }
}
